import { NgModule } from 'ng-metadata/core';
import { SnackbarComponent } from './snackbar.component';
import { SnackbarService } from './snackbar.service';
import * as angular from 'angular';
import './snackbar.scss';

angular.module('mwAppComponents.snackbar.services', [])
    .service('mwSnackbarService', SnackbarService);


/**
 * @ngdoc module
 * @name mw.components.snackbar
 * @description
 *
 * Snackbar
 */
@NgModule({
    declarations: [SnackbarComponent],
    providers: [{provide: 'mwSnackbarService', useClass: SnackbarService}],
    imports: ['mwAppComponents.snackbar.services']
})
export class SnackbarModule {}



// WEBPACK FOOTER //
// ./src/lib/components/snackbar/snackbar.module.ts